export default {
    data () {
        return {
            __langKeys: {}
        }
    },

    computed: {
        trans () {
            const data = {}
            const keys = Object.keys(this.__langKeys)
            for (let i = 0; i < keys.length; i++) {
                const module = keys[i]
                data[module] = {}
                for (let j = 0; j < this.__langKeys[module].length; j++) {
                    const key = this.__langKeys[module][j]
                    data[module][key] = this.$vuetify.lang.t(`$vuetify.${module}.${key}`)
                }
            }
            return data
        }
    },

    methods: {
        registerLang (keys = {}) {
            this.__langKeys = keys
        }
    }
}
